import { surChargeTypeDropdownOption, uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { GeneralProposalConstant, generalProposalIsRequiredFieldList, generalProposalTierRequiredFieldList } from "presentation/constant/GeneralProposal/GeneralProposalConstant";
import { useGeneralProposalVM } from "presentation/hook/GeneralProposal/useGeneralProposalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useGeneralProposalTracked } from "presentation/store/GeneralProposal/GeneralProposalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


export const TariffItemIsEditPanel = () => {
    const [generalProposalState] = useGeneralProposalTracked();
    const generalProposalVM = useGeneralProposalVM();
    const messageBarVM = useMessageBarVM();
    const GENERAL_PROPOSAL_CONSTANT = GeneralProposalConstant.Table;
    const { gnProposalState, generalProposalItemIsList, generalProposalItemTierList, currentEditTariffItemTier, currentEditTariffItemIs, isAddIs, isAddTier, isEditIs, isEditTier } = generalProposalState;
    const { isSaveClicked, allFormState } = gnProposalState;
    const handleSave = useCallback(() => {
        if (currentEditTariffItemIs) {
            if (isAddIs || isEditIs) {
                if (!currentEditTariffItemIs.shiftCode) {
                    messageBarVM.showError("Shift Code is mandatory.");
                    return;
                }
                if (currentEditTariffItemIs.percentage === null) {
                    messageBarVM.showError("Surcharge % is mandatory.");
                    return;
                }
                if (generalProposalItemIsList && generalProposalItemIsList.length > 0 && generalProposalItemIsList?.find(entity => entity.shiftCode === currentEditTariffItemIs.shiftCode && (entity.id !== currentEditTariffItemIs.id || entity.tempKey !== currentEditTariffItemIs.tempKey))) {
                    messageBarVM.showError("Duplicate record found, please check the key: Shift Code.");
                    return;
                }
                if (isAddIs && generalProposalItemTierList && generalProposalItemTierList.length > 1) {
                    messageBarVM.showError("Intensive surcharge does not support multiple charge tier.");
                    return;
                }
            }
        }

        if (currentEditTariffItemTier) {
            if (isAddTier || isEditTier) {
                // if (currentEditTariffItemTier.minimum === null) {
                //     messageBarVM.showError("MINIMUM is mandatory.");
                //     return;
                // }
                // if (currentEditTariffItemTier.rate === null) {
                //     messageBarVM.showError("RATE is mandatory.");
                //     return;
                // }
                // if (!currentEditTariffItemTier.uom) {
                //     messageBarVM.showError("UOM is mandatory.");
                //     return;
                // }
                // if (!currentEditTariffItemTier.forevery) {
                //     messageBarVM.showError("FOR_EVERY is mandatory.");
                //     return;
                // }
                // if (!currentEditTariffItemTier.cycle) {
                //     messageBarVM.showError("CYCLE is mandatory.");
                //     return;
                // }
                if (isAddTier && generalProposalItemIsList && generalProposalItemIsList.length > 0 && generalProposalItemTierList && generalProposalItemTierList.length === 1) {
                    messageBarVM.showError("Intensive surcharge does not support multiple charge tier.");
                    return;
                }
                if (Number(currentEditTariffItemTier.minimum) > Number(currentEditTariffItemTier.rate)) {
                    messageBarVM.showError("The Minimum should not be larger than Rate.");
                    return;
                }
                if ((!currentEditTariffItemTier.surcharge && currentEditTariffItemTier.surchargeType)
                    || (currentEditTariffItemTier.surcharge && !currentEditTariffItemTier.surchargeType)) {
                    messageBarVM.showError("Please input SURCHARGE and  SURCHARGE TYPE together");
                    return;
                }
                if ((!currentEditTariffItemTier.additionalUom && currentEditTariffItemTier.additionalRate)
                    || (currentEditTariffItemTier.additionalUom && !currentEditTariffItemTier.additionalRate)) {
                    messageBarVM.showError("Please input ADDITIONAL UOM and  ADDITIONAL RATE together");
                    return;
                }
                if (Number(currentEditTariffItemTier.rate) > Number(99999999.00) || Number(currentEditTariffItemTier.rate) < Number(-99999999.00)) {
                    messageBarVM.showError("RATE should be range from -99,999,999.00 to 99,999,999.00.");
                    return;
                }
                if (Number(currentEditTariffItemTier.minimum) > Number(99999999.00) || Number(currentEditTariffItemTier.minimum) < Number(-99999999.00)) {
                    messageBarVM.showError("MINIMUM RATE should be range from -99,999,999.00 to 99,999,999.00.");
                    return;
                }
                if (Number(currentEditTariffItemTier.additionalRate) > Number(99999999.00) || Number(currentEditTariffItemTier.additionalRate) < Number(-99999999.00)) {
                    messageBarVM.showError("ADDITIONAL RATE should be range from -99,999,999.00 to 99,999,999.00.");
                    return;
                }
                if (Number(currentEditTariffItemTier.surcharge) > Number(99999999.00) || Number(currentEditTariffItemTier.surcharge) < Number(0)) {
                    messageBarVM.showError("SURCHARGE should be range from 0.00 to 99,999,999.00.");
                    return;
                }
            }
        }

        generalProposalVM.onSaveClicked();
        generalProposalVM.onTempSaveClick((isAddIs || isEditIs) ? "generalProposalItemIsList" : "generalProposalItemTierList",
            (isAddIs || isEditIs) ? generalProposalState.currentEditTariffItemIs : generalProposalState.currentEditTariffItemTier)

    }, [generalProposalItemIsList, generalProposalItemTierList, currentEditTariffItemIs, currentEditTariffItemTier, generalProposalState.currentEditTariffItemIs, generalProposalState.currentEditTariffItemTier, generalProposalVM, isAddIs, isAddTier, isEditIs, isEditTier, messageBarVM]);

    const handleCancel = useCallback(() => {
        generalProposalVM.cancelAddOrEdit();
    }, [generalProposalVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        generalProposalVM.onTierFieldChange(fieldName, fieldValue);
    }, [generalProposalVM]);

    const memoCycle = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.cycle?.toString() || ''}
                fieldValue={currentEditTariffItemTier?.cycle?.toString()}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.CYCLE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'cycle'}
                maxLength={60}
                requiredFieldList={generalProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} */}
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.CYCLE}
                maxLength={10}
                fieldName={"cycle"}
                value={currentEditTariffItemTier?.cycle ?? ''}
                errorMessage={allFormState ? allFormState["cycle"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.CYCLE, allFormState, currentEditTariffItemTier?.cycle, onNumberFieldChange])

    const memoForEvery = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.forevery?.toString() || ''}
                fieldValue={currentEditTariffItemTier?.forevery?.toString()}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.FOR_EVERY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forevery'}
                maxLength={60}
                requiredFieldList={generalProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} */}
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.FOR_EVERY}
                maxLength={10}
                fieldName={"forevery"}
                value={currentEditTariffItemTier?.forevery ?? ''}
                errorMessage={allFormState ? allFormState["forevery"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.FOR_EVERY, allFormState, currentEditTariffItemTier?.forevery, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.uom || ''}
                fieldValue={currentEditTariffItemTier?.uom}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'uom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={generalProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.UOM, allFormState, currentEditTariffItemTier?.uom, generalProposalVM, isSaveClicked])

    const memoRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.RATE}
                maxLength={12}
                fieldName={"rate"}
                value={currentEditTariffItemTier?.rate ?? ''}
                errorMessage={allFormState ? allFormState["rate"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />

        </div>
        , [GENERAL_PROPOSAL_CONSTANT.RATE, allFormState, currentEditTariffItemTier?.rate, onNumberFieldChange])

    const memoMinimun = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.MINIMUM}
                maxLength={12}
                fieldName={"minimum"}
                value={currentEditTariffItemTier?.minimum ?? ''}
                errorMessage={allFormState ? allFormState["minimum"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.MINIMUM, allFormState, currentEditTariffItemTier?.minimum, onNumberFieldChange])

    const memosurCharge = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.SURCHARGE}
                maxLength={12}
                fieldName={"surcharge"}
                value={currentEditTariffItemTier?.surcharge ?? ''}
                errorMessage={allFormState ? allFormState["surcharge"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />

        </div>
        , [GENERAL_PROPOSAL_CONSTANT.SURCHARGE, allFormState, currentEditTariffItemTier?.surcharge, onNumberFieldChange])

    const memoSurChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.surchargeType || ''}
                fieldValue={currentEditTariffItemTier?.surchargeType}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.SURCHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'surchargeType'}
                maxLength={60}
                options={surChargeTypeDropdownOption}
                requiredFieldList={generalProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.SURCHARGE_TYPE, allFormState, currentEditTariffItemTier?.surchargeType, generalProposalVM, isSaveClicked])

    const memoAdditionalRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_RATE}
                maxLength={12}
                fieldName={"additionalRate"}
                value={currentEditTariffItemTier?.additionalRate ?? ''}
                errorMessage={allFormState ? allFormState["additionalRate"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_RATE, allFormState, currentEditTariffItemTier?.additionalRate, onNumberFieldChange])

    const memoAdditionalUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditTariffItemTier?.additionalUom || ''}
                fieldValue={currentEditTariffItemTier?.additionalUom}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'additionalUom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={generalProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_UOM, allFormState, currentEditTariffItemTier?.additionalUom, generalProposalVM, isSaveClicked])

    const memoShiftCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={currentEditTariffItemIs?.shiftCode || ''}
                fieldValue={currentEditTariffItemIs?.shiftCode}
                fieldLabel={GENERAL_PROPOSAL_CONSTANT.SHIFT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shiftCode'}
                maxLength={60}
                options={generalProposalState.dynamicOptions.shiftCodeDropdownOptions}
                requiredFieldList={generalProposalIsRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    generalProposalVM.onIsFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [GENERAL_PROPOSAL_CONSTANT.SHIFT_CODE, allFormState, currentEditTariffItemIs?.shiftCode, generalProposalState.dynamicOptions.shiftCodeDropdownOptions, generalProposalVM, isSaveClicked])

    const memoPercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={GENERAL_PROPOSAL_CONSTANT.SURCHARGE_P}
                maxLength={12}
                fieldName={"percentage"}
                value={currentEditTariffItemIs?.percentage ?? ''}
                errorMessage={allFormState ? allFormState["percentage"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => generalProposalVM.onIsFieldChange(fieldKey, fieldValue)}
            />

        </div>
        , [GENERAL_PROPOSAL_CONSTANT.SURCHARGE_P, allFormState, currentEditTariffItemIs?.percentage, generalProposalVM])



    return <div className='side-form-content-wrapper'>

        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>
                        {isAddTier && "Add " + GENERAL_PROPOSAL_CONSTANT.TIER_VALUE}
                        {isEditTier && "Update " + GENERAL_PROPOSAL_CONSTANT.TIER_VALUE}
                        {isAddIs && "Add " + GENERAL_PROPOSAL_CONSTANT.IS_VALUE}
                        {isEditIs && "Update " + GENERAL_PROPOSAL_CONSTANT.IS_VALUE}
                    </SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handleCancel} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handleSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        <div className={'add-edit-form'} style={{ height: '27vh', maxHeight: '27vh', overflow: 'visible', zIndex: '100' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {(isAddTier || isEditTier) &&
                        <><CriteriaItemContainer>
                            {memoCycle}
                            {memoForEvery}
                            {memoUom}
                            {memoRate}
                            {memoMinimun}
                            {memosurCharge}
                            {memoSurChargeType}
                            {memoAdditionalRate}
                            {memoAdditionalUom}
                        </CriteriaItemContainer>
                        </>}
                    {(isAddIs || isEditIs) &&
                        <>
                            <CriteriaItemContainer>
                                {memoShiftCode}
                                {memoPercentage}
                            </CriteriaItemContainer>
                        </>}
                </div>
            </div>
        </div>

        {/*
            <StyledAction className="tm-animated-wrapper">
                {<HPHButton disabled={false} label={WorkspaceConstant.Common.BUTTON_SAVE} size={'Small'} theme={'Primary'} onClick={handleSave} />}
            </StyledAction>
        */}
    </div>;
}

